export const CONTENT_ITEM_CARD_WIDTH = 288
export const CONTENT_ITEM_CARD_HEIGHT = 512
export const CONTENT_ITEM_MEDIA_ASPECT_RATIO = CONTENT_ITEM_CARD_WIDTH / CONTENT_ITEM_CARD_HEIGHT
